import Layout from '../components/Layout';

function Projects() {
  return (
    <Layout>
      <div className="container mx-auto px-8 py-8 h-full overflow-auto">
        <div className="space-y-6">
          <h1 className="text-3xl font-bold text-white">Projects</h1>
          <div className="bg-gray-800 rounded-xl shadow-2xl p-6 border border-gray-700">
            <h2 className="text-xl font-semibold text-white mb-4">
              Your Projects
            </h2>
            <p className="text-gray-400">
              Project management features will appear here.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Projects;
